<template>
  <div>
    <v-row v-if="loading" class="fill-height" align-content="center" justify="center">
      <v-col class="subtitle-1 text-center" cols="12">
        Cargando Permisos
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
    <div v-if="type == 'Cards'">
      <template v-for="(item, index) in items">
        <v-expansion-panels :key="index" :value="0" class="mt-1">
          <v-expansion-panel>
            <v-expansion-panel-header>{{ item.id }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <template v-for="(permisoDepto, index) in item.PermisosDpto">
                <table :key="index">
                  <tr>
                    <td style="font-size: 10px; width: 200px">
                      {{ permisoDepto.deptoNombre }}
                    </td>
                    <template
                      v-for="(permiso, indexPerm) in permisoDepto.Permisos"
                    >
                      <td :key="indexPerm" style="width: 150px">
                        <v-checkbox
                          :label="permiso.Nombre"
                          v-model="permiso.value"
                          :value="true"
                          style="margin-top: 0px; height: 25px; font-size: 10px"
                        ></v-checkbox>
                      </td>
                    </template>
                  </tr>
                </table>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </div>
    <v-simple-table v-if="type == 'Table'" fixed-header :height="500" dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th style="width: 10%" class="text-left">Permiso</th>
            <th style="width: 90%" class="text-left">Opciones</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in items">
            <PermisosTableRow :key="index" :item="item"></PermisosTableRow>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<style scoped>
</style>


<script>
import PermisosTableRow from "../MainComponents/PermisosTableRow.vue";
import Permisos from "../../clases/Permisos.js";
const userPermissions = new Permisos("Admin");

export default {
  name: "PermisosTable",
  components: { PermisosTableRow },
  props: ["height", "edit", "type", "objId", "rolsData", "patchData"],
  data() {
    return {
      loading:false,
      selection: [],
      items: [], //userPermissions.getMenuAsRow(false,"Mayorista"),
      globalPermissions: userPermissions.getGlobalPermissions(),
    };
  },
  methods: {
    getPermisos() {
      return JSON.stringify(
        userPermissions.PermissionDataFormToServer(this.items)
      );
    },
  },
  computed: {},
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.loading = true;
    setTimeout(async () => {
      if (!this.edit) {
        this.items = userPermissions.getGlobalPermissions();
      } else {
        this.items = userPermissions.PermissionServerToDataForm(
          this.rolsData,
          this.patchData
        );
      }
      this.loading = false;
    }, 1000);
  },
};
</script>